import {Search} from 'lucide-react';
import {Input} from '@/components/ui/Input';
import {ThemeToggle} from './ThemeToggle';
import {UserMenu} from '@/components/UserMenu';

export function Topbar() {
  return (
    <header className="h-16 shrink-0 border-b bg-card/40 backdrop-blur-sm flex items-center gap-4 px-6">
      <div className="flex-1 max-w-xl relative">
        <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" />
        <Input className="pl-9" placeholder="Search transactions…" />
      </div>
      <div className="ml-auto flex items-center gap-1">
        <ThemeToggle />
        <UserMenu />
      </div>
    </header>
  );
}
